import React, { createContext, useEffect, useState, useRef, useMemo } from 'react'
import {
  Table,
  Form,
  Button,
  Alert,
  message,
  ConfigProvider,
  Empty,
  Checkbox,
  Tooltip,
  Popover,
  Pagination,
  Divider,
} from 'antd'
import { getColumns } from './components/columns'
import { shopLogClstag } from '../shop/log'
import { erpLogClstag } from '../erp/log'
import { resSetCode, Status } from './components/columns/type'
import ApplyModal from './components/applyModal'
// import AcorePagination from '../pager'
import SkuInfo from '../sku-info'
import { useRouteMatch } from 'react-router-dom'
// import { promiseStream } from '@micro-zoe/micro-app/libs/utils'
// import { getMaterialList } from 'SERVICES/battleFiled'
export const TableContext = createContext({})
export const UserFeedbackComContext = createContext(null)
export const AppTypeContext = createContext(null)

const MaterialTables = (props) => {
  const {
    onChange,
    type = 'shop',
    contorlItems = [],
    dataSource,
    dataSpuSource,
    sucHeaderList = [],
    save = () => {},
    batchSave = () => {},
    batchSaves = () => {},
    onSearchs = () => {},
    loading = false,
    pagination,
    showFeedBack = () => {},
    needBatchSave = true,
    apiUrl = {
      getImgZoneSort: () => {},
      getImgZoneList: () => {},
      uploadImgZone: '',
    },
    searchMaxWidth,
    spuFlow,
    isProd,
    planCode,
    getMaterialList,
    SwitchTab,
  } = props
  const [form] = Form.useForm()
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [columns, setColumns] = useState([])
  const [columnspu, setColumnspu] = useState([
    {
      title: 'SPU商品信息',
      dataIndex: 'spuName',
      key: 'spuName',
      align: 'left',
      render: (skuId, record) => <SkuInfo data={record} hideCategoryInfo isApplyList showSkuCount showSpuIdCopyIcon />,
    },
    {
      title: '类目',
      dataIndex: 'categoryName',
      key: 'categoryName',
    },
  ])
  const [visible, setVisible] = useState(false)
  const [loadings, setLoadings] = useState(false)
  const [firstComeIn, setFirstComeIn] = useState(false)
  const [data, setData] = useState([])
  const [datas, setDatas] = useState([]) // 所有的spu
  const [sku, setSku] = useState([]) // 单个spu下的sku
  const [skus, setSkus] = useState([]) // 所有的skulist
  const [skuCache, setSkuCache] = useState({}) // 点加号时缓存sku
  const updateConfig = useRef({
    status: true, // true 全部更新 false 不更新
    skuId: '', // skuId 有值时 只更新id
  })
  const [spuRowKey, setSpuRowKey] = useState([])

  useEffect(() => {
    const isFirst = localStorage.getItem('BatchBtnFirst')
    setFirstComeIn(isFirst === '1' ? false : true)
    localStorage.setItem('BatchBtnFirst', '1')
  }, [])

  useEffect(() => {
    if (sucHeaderList && sucHeaderList.length) {
      setColumns(sucHeaderList.map((item) => getColumns(item, updateConfig, isProd)))
    }
  }, [sucHeaderList, data, skus])

  useEffect(() => {
    setData([])
    if (dataSource && dataSource.length) {
      updateConfig.current = {
        status: true,
        skuId: '',
      }
      setData([...dataSource])
    }
  }, [dataSource])

  useEffect(() => {
    setDatas([])
    if (dataSpuSource && dataSpuSource.length) {
      updateConfig.current = {
        status: true,
        skuId: '',
      }
      setDatas([...dataSpuSource])
    }
  }, [dataSpuSource])

  const updateData = ({ status, skuId }) => {
    updateConfig.current = {
      status,
      skuId,
    }
    setData([...data])
    setSku([...sku])
    setSkus([...skus])
    setSkuCache([...skuCache])
  }

  // const updateSpu = ({ status, skuId }) => {
  //   updateConfig.current = {
  //     status,
  //     skuId,
  //   }
  //   setSkus([...skus])
  //   setSku([...sku])
  //   setSkuCache([...skuCache])
  // }

  const editMutApplyRes = (res, out) => {
    if (res && res.length) {
      res.forEach((item) => {
        data.forEach((i) => {
          if (i.skuId === item.skuId) {
            resSetCode.forEach((code) => {
              const postFormData = out.filter((s) => i.skuId === s.skuId)[0]
              if (i[code]) {
                i[code].value = postFormData[code]
              } else {
                i[code] = {
                  value: postFormData[code],
                }
              }
              i.skuMaterialStatus = Status['审核中']
              i.editorStatus = false
              if (item[code] && item[code].failReason && i[code]) {
                i[code].failReason = item[code].failReason
                i[code].status = 5
                i.skuMaterialStatus = Status['审核失败']
                i.editorStatus = true
              } else {
                i[code].failReason = ''
                i[code].status = 3
              }
            })
            if (i['smartPicTransparent']) {
              i['smartPicTransparent'].failReason = ''
            }
            if (i['smartPicWhite']) {
              i['smartPicWhite'].failReason = ''
            }
          }
        })
      })
      updateData({ status: false, skuId: out.map((i) => i.skuId).join(',') })
    } else {
      data.forEach((i) => {
        out.forEach((item) => {
          if (item.skuId === i.skuId) {
            i.skuMaterialStatus = Status['审核中']
            i.editorStatus = false
          }
        })
      })
      updateData({ status: false, skuId: '' })
    }
  }

  const editMutApplyReSpu = (res, out) => {
    if (res && res.length) {
      res.forEach((item) => {
        skus.forEach((i) => {
          if (i.skuId === item.skuId) {
            resSetCode.forEach((code) => {
              const postFormData = out.filter((s) => i.skuId === s.skuId)[0]
              if (i[code]) {
                i[code].value = postFormData[code]
              } else {
                i[code] = {
                  value: postFormData[code],
                }
              }
              i.skuMaterialStatus = Status['审核中']
              i.editorStatus = false
              if (item[code] && item[code].failReason && i[code]) {
                i[code].failReason = item[code].failReason
                i[code].status = 5
                i.skuMaterialStatus = Status['审核失败']
                i.editorStatus = true
              } else {
                i[code].failReason = ''
                i[code].status = 3
              }
            })
            if (i['smartPicTransparent']) {
              i['smartPicTransparent'].failReason = ''
            }
            if (i['smartPicWhite']) {
              i['smartPicWhite'].failReason = ''
            }
          }
        })
      })
      updateData({ status: false, skuId: out.map((i) => i.skuId).join(',') })
    } else {
      skus.forEach((i) => {
        out.forEach((item) => {
          if (item.skuId === i.skuId) {
            i.skuMaterialStatus = Status['审核中']
            i.editorStatus = false
          }
        })
      })
      updateData({ status: false, skuId: '' })
    }
  }

  const validateItem = (item) => {
    return new Promise((s) => {
      form
        .validateFields(item)
        .then((e) => {
          s(e)
        })
        .catch((r) => {
          if (!r.errorFields.length) {
            s(r.values)
          } else {
            s(false)
          }
        })
    })
  }

  const getSaveData = (item, key) => {
    const saveMap = {
      skuId: data[+key].skuId,
    }
    Object.keys(item).forEach((i) => {
      saveMap[i.split('-')[1]] = item[i]
    })
    return saveMap
  }

  // 情况：不是全部校验通过的情况
  const partApply = async (rowItemsMaps, type) => {
    const keys = Object.keys(rowItemsMaps)
    const len = Object.keys(rowItemsMaps).length
    const outArr = []
    for (let index = 0; index < len; index++) {
      const element = rowItemsMaps[keys[index]]
      const iData = await validateItem(element)
      if (iData) {
        outArr.push(getSaveData(iData, keys[index]))
      }
    }
    if (outArr.length) {
      type === 'spuBatchSave'
        ? batchSaves(outArr, (res) => {
            if (res) {
              editMutApplyReSpu(res, outArr)
            }
          })
        : batchSave(outArr, (res) => {
            if (res) {
              editMutApplyRes(res, outArr)
            }
          })
    }
  }

  const onFinish = () => {
    const formNames = sucHeaderList.filter((item) => item.formItem).map((item) => item.id)
    // 暂时特殊处理下
    if (formNames.some((i) => i === 'smartContentSell')) {
      formNames.push(...['smartContentSell2', 'smartContentSell3'])
    }
    const formItemNames = []
    const rowItemsMaps = {}
    data.forEach((item, index) => {
      if (item.editorStatus) {
        formNames.forEach((i) => {
          formItemNames.push(`${index}-${i}`)
        })
        rowItemsMaps[index] = formNames.map((i) => `${index}-${i}`)
      }
    })
    if (formItemNames.length) {
      form
        .validateFields(formItemNames)
        .then((r) => {
          const out = []
          data.forEach((item, index) => {
            if (item.editorStatus) {
              const postForm = {
                skuId: item.skuId,
              }
              formNames.forEach((i) => {
                postForm[i] = r[`${index}-${i}`]
              })
              out.push(postForm)
            }
          })
          batchSave(out, (res) => {
            if (res) {
              editMutApplyRes(res, out)
            }
          })
        })
        .catch(() => {
          partApply(rowItemsMaps, 'skuBatchSave')
        })
    } else {
      message.error('无可更新素材')
    }
  }
  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys([...newSelectedRowKeys])
  }

  const onFinishs = () => {
    const formNames = sucHeaderList.filter((item) => item.formItem).map((item) => item.id)
    // 暂时特殊处理下
    if (formNames.some((i) => i === 'smartContentSell')) {
      formNames.push(...['smartContentSell2', 'smartContentSell3'])
    }
    const formItemNames = []
    const rowItemsMaps = {}
    for (const key in skuCache) {
      skuCache[key].forEach((item, index) => {
        if (item.editorStatus) {
          formNames.forEach((i) => {
            formItemNames.push(`${item.spuId}-${item.skuId}-${index}-${i}`)
          })
          rowItemsMaps[index] = formNames.map((i) => `${item.spuId}-${item.skuId}-${index}-${i}`)
        }
      })
    }
    const r = form.getFieldsValue(true)
    if (formItemNames.length) {
      form
        .validateFields(formItemNames)
        .then(() => {
          const out = []
          for (const key in skuCache) {
            skuCache[key].forEach((item, index) => {
              if (item.editorStatus) {
                const postForm = {
                  skuId: item.skuId,
                }
                formNames.forEach((i) => {
                  postForm[i] = r[`${item.spuId}-${item.skuId}-${index}-${i}`]
                })
                out.push(postForm)
              }
            })
          }
          batchSaves(out, (res) => {
            if (res) {
              editMutApplyReSpu(res, out)
            }
          })
        })
        .catch(() => {
          partApply(rowItemsMaps, 'spuBatchSave')
        })
    } else {
      message.error('无可更新素材')
    }
  }

  const rowSelection = {
    selectedRowKeys,
    renderCell: (checked, record) => {
      return (
        <span clstag="pageclick|keycount|supplement_material_1667200329665|1">
          <Checkbox
            checked={checked}
            onChange={(e) => {
              if (e.target.checked) {
                setSelectedRowKeys([...selectedRowKeys, record.skuId])
              } else {
                setSelectedRowKeys([...selectedRowKeys.filter((i) => i !== record.skuId)])
              }
            }}
          ></Checkbox>
        </span>
      )
    },
    onChange: onSelectChange,
  }

  const onExpand = async (expanded, record) => {
    if (record.spuId) {
      setSpuRowKey([record.spuId])
    }
    // 已展开过存在缓存数据，后续收起再展开不重新请求接口
    if (skuCache[record.spuId]?.length) return
    setLoadings(true)
    props
      .getMaterialList({
        goodsId: record.spuId,
        page: 1,
        pageSize: 200,
        planCode,
        goodsType: 1,
        applyStatusCode: 'APPLIED',
      })
      .then((res) => {
        const pageNum = res.totalPage || res.data.totalPage
        if (pageNum > 1) {
          const result = Array.from({ length: pageNum }, (_, i) => i).map((item) =>
            props.getMaterialList({
              page: item + 1,
              pageSize: 200,
              planCode,
              goodsId: record.spuId,
              goodsType: 1,
              applyStatusCode: 'APPLIED',
            })
          )
          Promise.all(result)
            .then((p) => {
              const skuArray = p.flatMap((obj) => obj.items)
              const _skuCache = {}
              skuArray.forEach((i) => {
                if (i.skuMaterialStatus === Status['未完善'] || i.skuMaterialStatus === Status['审核失败']) {
                  i.editorStatus = true
                } else {
                  i.editorStatus = false
                }
              })
              _skuCache[record.spuId] = skuArray.map((item) => ({
                ...item,
                skuId: item.sku || item.skuId,
              }))
              setSkuCache({ ...skuCache, ..._skuCache })
              setSku([...skuArray])
              setLoadings(false)
              // const allSkuId = sku.map((i) => i.skuId)
              // const allSkuList = []
              // skuArray.map((item) => {
              //   // if (!allSkuId.includes(item.skuId)) {
              //     allSkuList.push(item)
              //   // }
              // })
            })
            .catch((error) => {
              setLoadings(false)
              console.log(error)
            })
        } else {
          if (type === 'erp') {
            res = res.data
          }
          const skuArray = [...res.items]
          const _skuCache = { ...skuCache }
          skuArray.forEach((i) => {
            if (i.skuMaterialStatus === Status['未完善'] || i.skuMaterialStatus === Status['审核失败']) {
              i.editorStatus = true
            } else {
              i.editorStatus = false
            }
          })
          _skuCache[record.spuId] = skuArray.map((item) => ({
            ...item,
            skuId: item.sku || item.skuId,
          }))
          setSkuCache(_skuCache)
          setSku([...skuArray])
          setLoadings(false)
        }
      })
  }

  useEffect(() => {
    if (skuCache) {
      const allSkuList = [].concat(...Object.values(skuCache))
      setSkus([...allSkuList])
    }
  }, [skuCache])

  const expandedRowRender = (record) => {
    return (
      <Table
        rowKey={(rec) => `${rec.spuId}-${rec.skuId}`}
        // rowSelection={rowSelection}
        columns={columns}
        dataSource={skuCache[record.spuId] || []}
        loading={loadings}
        scroll={{ x: 1200, y: 900 }}
        pagination={false}
        sticky
      />
    )
  }
  const renderTable = useMemo(() => {
    return (
      <Table
        columns={columnspu}
        rowKey={(rec) => `${rec.spuId}`}
        scroll={{ y: 730 }}
        loading={loading}
        expandable={{
          expandedRowRender,
          onExpand,
        }}
        dataSource={datas}
        pagination={false}
        sticky
      />
    )
  }, [spuRowKey, columnspu, datas, expandedRowRender])
  const renderTableContext = useMemo(() => {
    return (
      <TableContext.Provider
        value={{
          ...apiUrl,
          form,
          uploadImgUrl: props.uploadImgUrl,
          updateData,
          save,
          showErpFeedBack: () => {},
          data: skus,
          skuCache,
          setSkuCache,
        }}
      >
        <Form form={form} className="custom-info-table">
          <AppTypeContext.Provider value={type}>
            <ApplyModal
              visible={visible}
              setVisible={setVisible}
              batchSave={batchSave}
              selectedRowKeys={selectedRowKeys}
              editMutApplyRes={editMutApplyRes}
            />
            <UserFeedbackComContext.Provider value={type === 'shop' ? showFeedBack : null}>
              <ConfigProvider
                renderEmpty={() => (
                  <Empty description={<div>暂无可维护商品</div>} image={Empty.PRESENTED_IMAGE_SIMPLE} />
                )}
              >
                {renderTable}
              </ConfigProvider>
              <div style={{ textAlign: 'right', margin: '16px 0' }}>
                <Pagination
                  total={pagination.total}
                  onChange={onChange}
                  showSizeChanger={true}
                  defaultCurrent={1}
                  defaultPageSize={10}
                  current={pagination.current}
                  pageSizeOptions={[10, 20, 50]}
                  showTotal={(total) => `共 ${total} 条数据`}
                  showQuickJumper
                />
              </div>
            </UserFeedbackComContext.Provider>
          </AppTypeContext.Provider>
        </Form>
      </TableContext.Provider>
    )
  }, [skus, form, type, loadings, pagination, showFeedBack, datas])

  return (
    <div>
      <div style={{ margin: '10px 10px', display: 'flex', justifyContent: 'space-between' }}>
        <props.Search
          onChange={onSearchs}
          searchMaxWidth={searchMaxWidth}
          contorlItems={contorlItems}
          type={type}
          spuFlow={spuFlow}
        />
      </div>
      <Divider style={{ marginTop: 14 }} />
      <div style={{ display: 'flex' }}>
        {needBatchSave && (
          <Button
            style={{ borderRadius: 40 }}
            type="primary"
            shape="round"
            onClick={() => onFinishs()}
            clstag={type === 'shop' ? shopLogClstag['mutSaveBtnClick'] : erpLogClstag['mutSaveBtnClick']}
          >
            保存当前页信息
          </Button>
        )}
        <div style={{ marginLeft: 'auto' }}>{SwitchTab}</div>
      </div>
      {renderTableContext}
    </div>
  )
}

export default MaterialTables
